var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3336_2152)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3336_2152)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3336_2152)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_3336_2152",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2262 17.5126V14.6666H17.287V17.5126H14V18.3257H17.287V21.1716H18.2262V18.3257H21.5133V17.5126H18.2262Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18.2262 17.5126V14.6666H17.287V17.5126H14V18.3257H17.287V21.1716H18.2262V18.3257H21.5133V17.5126H18.2262Z",
    fill: "#2B2D4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2262 17.5126H16.2262V19.5126H18.2262V17.5126ZM18.2262 14.6666H20.2262V12.6666H18.2262V14.6666ZM17.287 14.6666V12.6666H15.287V14.6666H17.287ZM17.287 17.5126V19.5126H19.287V17.5126H17.287ZM14 17.5126V15.5126H12V17.5126H14ZM14 18.3257H12V20.3257H14V18.3257ZM17.287 18.3257H19.287V16.3257H17.287V18.3257ZM17.287 21.1716H15.287V23.1716H17.287V21.1716ZM18.2262 21.1716V23.1716H20.2262V21.1716H18.2262ZM18.2262 18.3257V16.3257H16.2262V18.3257H18.2262ZM21.5133 18.3257V20.3257H23.5133V18.3257H21.5133ZM21.5133 17.5126H23.5133V15.5126H21.5133V17.5126ZM20.2262 17.5126V14.6666H16.2262V17.5126H20.2262ZM18.2262 12.6666H17.287V16.6666H18.2262V12.6666ZM15.287 14.6666V17.5126H19.287V14.6666H15.287ZM17.287 15.5126H14V19.5126H17.287V15.5126ZM12 17.5126V18.3257H16V17.5126H12ZM14 20.3257H17.287V16.3257H14V20.3257ZM15.287 18.3257V21.1716H19.287V18.3257H15.287ZM17.287 23.1716H18.2262V19.1716H17.287V23.1716ZM20.2262 21.1716V18.3257H16.2262V21.1716H20.2262ZM18.2262 20.3257H21.5133V16.3257H18.2262V20.3257ZM23.5133 18.3257V17.5126H19.5133V18.3257H23.5133ZM21.5133 15.5126H18.2262V19.5126H21.5133V15.5126Z",
    fill: "black",
    mask: "url(#path-3-inside-1_3336_2152)"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 18,
    height: 18,
    rx: 2,
    stroke: "#2B2D4E",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3336_2152",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3336_2152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3336_2152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3336_2152",
    x: 6,
    y: 6.66663,
    width: 23.5132,
    height: 22.505,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3336_2152"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3336_2152",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3336_2152"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 20,
    height: 20,
    rx: 3,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonAdd);
export default __webpack_public_path__ + "static/media/carbon_add.1541a4a7339bf27c44f8f68f63f72cec.svg";
export { ForwardRef as ReactComponent };